import React, { useEffect, useState } from 'react';
import { Panel, Breadcrumb, Tabs } from 'rsuite';
import Schedule from './Schedule';
import MeetingSchedule from './MeetingSchedule';
import { useAppDispatch } from '@/config/hooks';
import { getBuildings } from '@/services/floor.service';
import './style.less';
import { useTranslation } from 'react-i18next';


const Page = () => {
  const dispatch = useAppDispatch();
  const [selectedTab, setSelectedTab] = useState('office');
  const [selectedFloor, setSelectedFloor] = useState(null);

  useEffect(() => {
    dispatch(getBuildings());
  }, []);

  useEffect(() => {
    setSelectedFloor(null);
  }, [selectedTab]);
  const { t } = useTranslation();
  return (
    <Panel
      header={
        <>
          <h3 className="title">{t('Resources schedule')}</h3>{' '}
          <Breadcrumb>
            <Breadcrumb.Item href="/">{t('Home')}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('Resources schedule')}</Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <Panel
        bodyFill
        style={{
          // background: '#fff',
          padding: 20
        }}
      >
        <Tabs
          defaultActiveKey="desks"
          appearance="subtle"
          onSelect={setSelectedTab}
          activeKey={selectedTab}
          style={{ fontSize: 15 }}
        >
          <Tabs.Tab eventKey="office" title={t("Desks")}>
            {/* <DesksBooking setSelectedTab={setSelectedTab} locationState={location.state} />{' '} */}
          </Tabs.Tab>
          <Tabs.Tab eventKey="parking" title={t("Parking spots")}>
            {/* {selectedTab == 'parking' && <ParkingBooking setSelectedTab={setSelectedTab} />} */}
          </Tabs.Tab>
          <Tabs.Tab eventKey="meetingRoom" title={t("Meeting rooms")}>
            {/* {selectedTab == 'meetingRooms' && <MeetingRooms />} */}
          </Tabs.Tab>
        </Tabs>
        {selectedTab == 'office' || selectedTab == 'parking' ? (
          <Schedule
            type={selectedTab}
            selectedFloor={selectedFloor}
            setSelectedFloor={setSelectedFloor}
          />
        ) : (
          <MeetingSchedule />
        )}
        {/* <Schedule /> */}
      </Panel>
    </Panel>
  );
};

export default Page;
